import Vue from "vue";

export default {
  actions: {
    login({ dispatch, commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .post("/users/login", data)
          .then((response) => {
            commit("setUser", {
              token: response.data.token,
              id: response.data.id,
              accessLevel: response.data.accessLevel,
              name: response.data.name,
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    logout({ commit }) {
      commit("setUser", {
        token: null,
        id: null,
        accessLevel: null,
        name: null,
      });
    },
    recalculateCrewHours({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .post("/users/recalculate-hours")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUsers({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getFreelancers({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/list/freelancers")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getCustomers({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/list/customers")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getCrewNames({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/crew/name")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUserNames({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/name")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUserHours({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/users/info/hours/query?" +
              new URLSearchParams({
                userFilter: data.userFilter,
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getCrewInfo({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/crew/info")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUsersByClient({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/user/client/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUser({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getRecentProjects({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/projects/recent/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUserPay({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/info/pay/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUserInfoBasic({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/info/basic/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUserHoursOverview({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/info/hours/overview/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUserInfoFull({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/info/full/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    addUser({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .post("/users/add", data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    addUserPayout({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .post("/users/payout", data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getPayout({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/payout/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getUserWorkYears({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/users/info/workyears/" + id)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getNotifications({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/notifications")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    markNotificationAsRead({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .patch("/notifications/" + id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    updateUser({ dispatch }, user) {
      return new Promise((resolve, reject) => {
        Vue.api
          .patch("/users/" + user._id, user)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    lockUser({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Vue.api
          .patch("/users/lock/" + id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    changePassword({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .patch("/password", data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    resetPassword({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .patch("/resetpassword", data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
  },
};
